/**
 * @description ダウンロードしたファイルの行数を数える。api-server は `limit` 超過を
 * 通知しないため、行数が `limit` に達しているかで「続きがある可能性」を判定するしかない。
 */

/** UTF-8 BOM。api-server は Excel 対策で CSV に付与する。 */
const BOM = "﻿";

/**
 * CSV のレコード数を数える (ヘッダー行を含む)。引用符の中の改行をレコード区切りと
 * 数えないよう、`split("\n")` ではなく RFC 4180 に沿って走査する。
 */
export const countCsvRecords = (text: string): number => {
  const body = text.startsWith(BOM) ? text.slice(BOM.length) : text;
  let records = 0;
  let inQuotes = false;
  // 空行を1レコードと数えないための「このレコードに文字があったか」
  let hasContent = false;
  for (let i = 0; i < body.length; i++) {
    const char = body[i];
    if (inQuotes) {
      // "" は引用符のエスケープなので引用の外に出ない
      if (char === '"' && body[i + 1] === '"') {
        i += 1;
      } else if (char === '"') {
        inQuotes = false;
      }
      hasContent = true;
      continue;
    }
    if (char === '"') {
      inQuotes = true;
      hasContent = true;
      continue;
    }
    if (char === "\n" || char === "\r") {
      if (char === "\r" && body[i + 1] === "\n") i += 1;
      if (hasContent) records += 1;
      hasContent = false;
      continue;
    }
    hasContent = true;
  }
  if (hasContent) records += 1;
  return records;
};

/** 解釈できなかった場合は `null` (ダウンロード自体は成功しているので失敗にはしない)。 */
export const countDownloadedRows = (
  text: string,
  format: "csv" | "json"
): number | null => {
  try {
    if (format === "json") {
      const parsed: unknown = JSON.parse(text);
      return Array.isArray(parsed) ? parsed.length : null;
    }
    // データ 0 行でもヘッダー行は出力される
    const records = countCsvRecords(text);
    return records === 0 ? null : records - 1;
  } catch {
    return null;
  }
};
